import { Component, OnInit } from '@angular/core'
import { SwitchComponent } from '@ftr/forms'
import { LaunchDarklyModule, LaunchDarklyService, LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY } from '@ftr/ui-feature-flags'
import { take } from 'rxjs'

@Component({
  selector: 'ftr-persistent-flag-switch',
  templateUrl: './persistent-flag-switch.component.html',
  imports: [SwitchComponent, LaunchDarklyModule],
})
export class PersistentFlagSwitchComponent implements OnInit {
  persistentFlagEnabled = false
  showSwitch = false

  constructor(private readonly launchDarklyService: LaunchDarklyService) {}

  ngOnInit(): void {
    this.persistentFlagEnabled = localStorage.getItem(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY) === 'true'

    this.launchDarklyService
      .observeFlagChanges<boolean>('persistent-flag-switch')
      .pipe(take(1))
      .subscribe(isEnabled => {
        this.showSwitch = isEnabled

        // Clean up localStorage if the flag is disabled and the key is set
        if (!isEnabled && localStorage.getItem(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)) {
          localStorage.removeItem(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)
          this.persistentFlagEnabled = false
        }
      })
  }

  onPersistentFlagChange(enabled: boolean): void {
    this.persistentFlagEnabled = enabled
    if (enabled) {
      localStorage.setItem(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY, 'true')
    } else {
      localStorage.removeItem(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)
    }
  }
}
